import { CSSProperties, ReactNode } from 'react'

import { Text } from '@hhgtech/hhg-components'

// import { IS_MARRY_BABY } from 'interfaces/constants'

import { StyledLabelSortPin } from './index.styled'

const IS_MARRY_BABY = true

export type Props = {
  label: ReactNode
  rightLabel?: ReactNode
  onClick?: () => unknown
  color?: 'gray' | 'white'
  className?: string
  style?: CSSProperties
}

const LabelSortPin = ({
  label,
  rightLabel,
  onClick,
  color,
  className,
  style,
}: Props) => {
  return (
    <StyledLabelSortPin
      data-color={color}
      onClick={onClick}
      className={className}
      style={style}
    >
      <Text
        className="label-sort-pin-heading"
        size={IS_MARRY_BABY ? 'p4' : 'p3'}
        type="bold"
      >
        {label}
      </Text>
      {rightLabel}
    </StyledLabelSortPin>
  )
}

export { LabelSortPin }
